class DaelivoNewsletterPopup extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.storageKey = 'daelivo:newsletter-popup:v1';
    this.listenersController = new AbortController();
    this.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal: this.listenersController.signal }));
    this.addEventListener('keydown', event => this.onKeydown(event), { signal: this.listenersController.signal });
    if (this.dataset.feedback) {
      this.open();
      return;
    }
    if (window.Shopify?.designMode || this.isSuppressed()) return;
    this.timer = window.setTimeout(() => this.openWhenAvailable(), Number(this.dataset.delay) || 5000);
  }

  openWhenAvailable() {
    if (!this.isConnected || this.isSuppressed()) return;
    const modalOpen = [...document.querySelectorAll(
      'cart-drawer[open], x-drawer[open], x-modal[open], x-popover[open], search-drawer[open], menu-drawer[open], header-menu-drawer[open], dialog[open], [role="dialog"][aria-modal="true"]'
    )].some(node => !this.contains(node) && (node.hasAttribute('open') || node.getClientRects().length));
    const editingField = document.activeElement?.matches('input, textarea, select, [contenteditable="true"], shopify-account');
    if (document.hidden || modalOpen || editingField) {
      this.timer = window.setTimeout(() => this.openWhenAvailable(), 1000);
      return;
    }
    this.open();
  }

  isSuppressed() {
    try {
      const record = JSON.parse(window.localStorage.getItem(this.storageKey) || 'null');
      return record?.subscribed === true || Number(record?.expiresAt) > Date.now();
    } catch { return false; }
  }

  remember() {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify({
        expiresAt: Date.now() + (Number(this.dataset.repeatMs) || 86400000),
        subscribed: this.dataset.feedback === 'success',
      }));
    } catch { /* Storage restrictions must not block the form. */ }
  }

  open() {
    if (!this.hidden) return;
    this.returnFocus = document.activeElement;
    this.hidden = false;
    this.remember();
    document.documentElement.classList.add('daelivo-newsletter-lock');
    this.querySelector('button[data-newsletter-close]')?.focus();
  }

  close() {
    window.clearTimeout(this.timer);
    this.hidden = true;
    document.documentElement.classList.remove('daelivo-newsletter-lock');
    if (this.returnFocus?.isConnected) this.returnFocus.focus();
  }

  disconnectedCallback() {
    this.listenersController?.abort();
    this.ready = false;
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
    if (event.key !== 'Tab') return;
    const items = [...this.querySelectorAll('button, input, a[href]')]
      .filter(node => !node.disabled && node.tabIndex >= 0 && node.getClientRects().length);
    const first = items[0], last = items.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }
}
if (!customElements.get('daelivo-newsletter-popup')) customElements.define('daelivo-newsletter-popup', DaelivoNewsletterPopup);
